import Parcel from "../../Parcel";
import ResponseError from "../../../../bootstrap/api/ResponseError";
import ResponseResult from "../../../../bootstrap/api/ResponseResult";

export default class DocumentUploadParcel extends Parcel {
    /**
     *
     * @param {File} file
     */
    constructor(file) {
        super();

        this.compose(file);
    }

    /**
     *
     * @param {File} file
     */
    compose(file) {
        this.setEndpoint('/api/document/create');
        this.setRequestMethod('POST');

        const formData = new FormData();
        formData.append('file_to_upload', file);

        this.setRequestBody(formData);
    }

    /**
     *
     * @param rawResult
     * @return {ResponseResult}
     */
    parseResponseResult(rawResult) {
        if (!rawResult.error) {
            /**
             *
             * @type {IDocument}
             */
            const document = rawResult.data;

            return new ResponseResult(document, null);
        }

        const responseError = new ResponseError(rawResult.error.message);

        return new ResponseResult(null, responseError);
    }

    /**
     *
     * @param rawError
     * @return {ResponseError}
     */
    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }
}
